import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import {Typography, styled} from '@mui/material'
import Tooltip, {TooltipProps, tooltipClasses} from '@mui/material/Tooltip'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../localization'

const StyledTooltip = styled(({className, ...props}: TooltipProps) => (
  <Tooltip {...props} arrow classes={{popper: className}} />
))(({theme}) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black
  }
}))

export const AnalysisDescriptionTooltip = ({top, left}: {top: number; left: number}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  return (
    <StyledTooltip
      arrow
      title={
        <Typography variant="body2" color="common.white">
          {`•${t('newAnalysis.descriptionTooltip1')}`}
          <br />
          {`•${t('newAnalysis.descriptionTooltip2')}`}
          <br />
          {`•${t('newAnalysis.descriptionTooltip3')}`}
          <br />
          {`•${t('newAnalysis.descriptionTooltip4')}`}
        </Typography>
      }
    >
      <InfoOutlinedIcon
        sx={{
          position: 'relative',
          top: top,
          left: left
        }}
      />
    </StyledTooltip>
  )
}
